import Image from 'next/image';

import { MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { siteService } from '@/services/site.service';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useGetDrawLeagueSetting } from '@/hooks/query/use-promotion-data';

import { LeagueLogo } from '../components/league-logo';
import { leagueIconStyle as styles } from './league-icon.style';
import { NBATag } from '@/features/promotion/golden-duel/components/nba-tag/nba-tag';

interface LeagueIconProps {
	leagueId: number;
	sport: number;
	parentMatchId?: number;
	enableOddsBoostPromo: boolean;
	isGoldenDuel: boolean;
	goldenDuelTag: 'normal' | 'small';
}

export const LeagueIcon = ({ leagueId, sport, parentMatchId, enableOddsBoostPromo, isGoldenDuel, goldenDuelTag }: LeagueIconProps) => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const { data: drawLeagueSetting } = useGetDrawLeagueSetting();
	
	if (enableOddsBoostPromo) {
		return (
			<img 
				className={styles.oddsBoostIcon} 
				src={siteService.combineImagePath('images/promotion/odds-boost-promo/oddsboost-promo-icon.png', true, SiteConfigsData)} 
				alt="odds-boost-promo" 
			/>
		);
	}

	if (isGoldenDuel) {
		return <NBATag size={goldenDuelTag} />;
	}
  
	if (sport === 999) return null;

	return MaybeMatch(
		SiteConfigsData?.EnableSingleMatchJackpot && 
		leagueId && 
		drawLeagueSetting?.split(',').includes(leagueId.toString()) && 
		parentMatchId == 0
	).fold(
		() => <LeagueLogo leagueId={leagueId} />,
		() => (
			<Image
				width="21"
				height="21"
				alt=""
				src={siteService.combineImagePath('/images/promotion/euro2024/jackpot-icon.png', true, SiteConfigsData)}
			/>
		)
	);
};